import { Component, ReactNode } from 'react'
import * as styles from 'styles/layouts/CommonLayout.css'
import LogoContainer from 'components/features/pfm/Logo/LogoContainer'
import CommonFooter from 'components/molecules/CommonFooter'
import { isShrunkSidebarSelector } from 'selectors/globalSelectors'
import { createSelector } from 'reselect'
import { connect } from 'react-redux'
import * as cn from 'classnames'
import { withRouter } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'
import withReadyEvent from 'hocs/withReadyEvent/withReadyEvent'
import { LogoSize } from 'components/features/pfm/Logo/Logo'

type CommonLayoutOwnProps = {
  header?: ReactNode
  headerButtons?: ReactNode[]
  logoSize?: LogoSize
}

type CommonLayoutStateProps = {
  isShrunkSidebar: boolean
}

type CommonLayoutInnerProps = RouteComponentProps<{}> & CommonLayoutOwnProps

type CommonLayoutProps = CommonLayoutOwnProps & CommonLayoutStateProps

class CommonLayoutComponent extends Component<CommonLayoutProps> {
  render () {
    const {
      header: customHeader,
      headerButtons,
      children,
      isShrunkSidebar,
      logoSize = 'responsive',
    } = this.props

    const header = customHeader
      ? customHeader
      : (
        <header className={ styles.header }>
          <LogoContainer size={ logoSize } />
          <section className={ styles.buttons }>
            { headerButtons && headerButtons.map((button, idx) => (
              <div className={ styles.buttonWrapper } key={ idx }>{ button }</div>
            )) }
          </section>
        </header>
      )

    const className = cn(styles.commonLayout, {
      [styles.isShrunkSidebar]: isShrunkSidebar,
    })

    return (
      <section className={ className }>
        <div className={ styles.content }>
          { header }
          { children }
          <div className={ styles.pushFooter } />
        </div>
        { this.renderFooter() }
      </section>
    )
  }

  renderFooter () {
    return (
      <CommonFooter />
    )
  }
}

const mapStateToProps = createSelector(
  isShrunkSidebarSelector,
  (isShrunkSidebar): CommonLayoutStateProps => ({
    isShrunkSidebar,
  })
)

const CommonLayoutInner = connect<
  CommonLayoutStateProps, {}, CommonLayoutInnerProps
>(mapStateToProps)(CommonLayoutComponent)
const CommonLayout = withRouter(withReadyEvent(CommonLayoutInner))

export default CommonLayout
